import { Link } from 'react-router-dom';
import { useBrand } from '../../hooks/useBrand';
import { brandAssetUrl } from '../../utils/brandAssetUrl';

type BrandMarkProps = {
  /** icon = square app mark (icon.svg); logo = full wordmark (logo.svg) */
  variant?: 'icon' | 'logo';
  /** Tailwind size classes, e.g. h-9 sm:h-10 or h-10 w-10 */
  size?: string;
  /** Omit or leave empty for non-link mark */
  to?: string;
  className?: string;
};

/**
 * Brand mark — logo.svg for wordmark, icon.svg for square app icon.
 */
export default function BrandMark({
  variant = 'logo',
  size = 'h-10',
  to = '/',
  className = '',
}: BrandMarkProps) {
  const brand = useBrand();
  const isIcon = variant === 'icon';

  const heightClass =
    size
      .split(/\s+/)
      .filter((c) => c.startsWith('h-'))
      .join(' ') || 'h-10';

  const widthClass = isIcon
    ? size
        .split(/\s+/)
        .filter((c) => c.startsWith('w-'))
        .join(' ') || heightClass.replace(/^h-/, 'w-')
    : '';

  const img = (
    <img
      src={brandAssetUrl(isIcon ? brand.iconSrc : brand.logoSrc)}
      alt={isIcon ? brand.name : brand.logoAlt}
      className={`max-w-full shrink-0 object-contain ${
        isIcon
          ? `${heightClass} ${widthClass}`.trim()
          : `${heightClass} w-auto max-w-[min(100%,280px)] object-left`
      } ${className}`}
      draggable={false}
    />
  );

  if (to && to.length > 0) {
    return (
      <Link
        to={to}
        className="inline-flex max-w-full min-w-0 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
        aria-label="tropayment home"
      >
        {img}
      </Link>
    );
  }

  return <span className="inline-flex min-w-0 max-w-full">{img}</span>;
}
